export default __webpack_public_path__ + "static/media/icon_choose_file.7543ebc1.jpg";